import Axios from 'axios';
import store from '@/store';
import { log } from '@/utils/common';

const instance = Axios.create();

// async request 설정 - spinner
instance.interceptors.request.use((config) => {
  if (!config.noSpinner) {
    store.dispatch('showSpinner');
  }
  return config;
}, (error) => {
  Promise.reject(error);
});

// async response 설정 - spinner 및 에러메세지
instance.interceptors.response.use((response) => {
  if (!response.config.noSpinner) {
    store.dispatch('hideSpinner');
  }

  if (response.data.errorType || response.data.errorMessage) {
    console.error(response.data);
    return Promise.reject(response.data);
  }

  log('http::response.use::', response);

  return response;
}, (error) => {
  store.dispatch('hideSpinner');
  log('http::response.use::', error);

  return Promise.reject(error);
});

/**
 * name: http.js
 * description: 전역으로 사용될 비동기 통신 객체 정의
 */
const baseUrl = process.env.VUE_APP_API_BASE_URL;
const defaultHeaders = {
  'Content-Type': 'application/json;charset=UTF-8',
};

// 비동기 통신 Object 정의
const httpInstance = {
  get(uri, params = {}, headers = {}, additionalConfig = {}) {
    const url = `${baseUrl}${uri}`;
    const config = {
      headers: {
        ...defaultHeaders,
        ...headers,
      },
      ...additionalConfig,
      params,
    };

    const promise = instance.get(url, config);
    return promise.then(({ data }) => data);
  },
  patch(uri, params = {}, headers = {}, additionalConfig = {}) {
    const url = `${baseUrl}${uri}`;
    const config = {
      headers: {
        ...defaultHeaders,
        ...headers,
      },
      ...additionalConfig,
    };

    const promise = instance.patch(url, params, config);
    return promise.then(({ data }) => data);
  },
  post(uri, params = {}, headers = {}, additionalConfig = {}) {
    const url = `${baseUrl}${uri}`;
    const config = {
      headers: {
        ...defaultHeaders,
        ...headers,
      },
      ...additionalConfig,
    };

    const promise = instance.post(url, params, config);
    return promise.then(({ data }) => data);
  },
  mockPost(uri, params = {}, expectingReturnVal = {}, timeout = 2 * 1000) {
    const url = `${uri}`;
    console.warn(`Mocking api - uri ${url} with params`, params);
    store.dispatch('showSpinner');
    return new Promise((resolve) => {
      setTimeout(() => {
        store.dispatch('hideSpinner');
        resolve(expectingReturnVal);
      }, timeout);
    });
  },
};

export const axios = instance;
export const http = httpInstance;
export default http;
